import Dropdown from "../components/Dropdown";

const checkDropdowns = (el) => {
  if (!el) return;
  const dropdowns = el.querySelectorAll('.dropdown');

  if(!dropdowns.length) return;
  [...dropdowns].forEach(dropdown => {
    new Dropdown(dropdown);
  });
}

export default checkDropdowns;
